module.exports = __webpack_public_path__ + "static/8-d36cdbd1e4fba50e5fd792206d452849.jpg";